<template>
    <div>
      <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
          <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
      </div>
      <div v-else>
        <v-row>
          <v-col xs="12" sm="12" md="8" lg="10" xl="10" cols="12">
            <div class="title_page ma-3">
              <h4 class="breadcrumb_title_page">ชำระเงิน</h4>
              <v-breadcrumbs :items="sub_menu">
                <template v-slot:divider>
                  <v-icon>mdi-chevron-right</v-icon>
                </template>
              </v-breadcrumbs>
            </div>
          </v-col>
        </v-row>
  
        <v-row class="mb-0">
            
            <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
  
                <v-card class="input-radius pa-2">
                    <v-card-title class="py-6">
                        <v-row>
                            <v-col cols="12" md="6" lg="6">
                                ช่องทางการโอนเงินผ่านธนาคาร
                            </v-col>
                            <v-col class="text-right font-red" cols="12" md="6" lg="6">
                                ยอดเงินชำระ {{formatPrice(total)}} บาท
                            </v-col>
                        </v-row>
                    </v-card-title>
                   <v-form ref="form" @submit.prevent="saveData()">
                     <v-card-text>
                        <v-row>
                           <v-col cols="12" sm="12" md="4"  lg="4" v-for="item in data_list" :key="item.id">
                                <v-card class="mx-auto input-radius boder-D6BFAF" height="100%" elevation="2" outlined>
                                    <v-list-item three-line >
                                        <v-list-item-content >
                                            <!-- <div class="text-overline mb-4 ">
                                                <v-img :lazy-src="bank_kasikorn" :src="bank_kasikorn" max-height="150px" max-width="150px"></v-img>
                                            </div> -->
                                            <v-list-item-title class="text-center mb-1">
                                                {{item.bank_name}}
                                            </v-list-item-title>
                                            <v-list-item-title class="text-center mb-1">
                                               {{item.bank_number}}
                                            </v-list-item-title>
                                            <v-list-item-subtitle class="text-center">{{item.bank_account}}</v-list-item-subtitle>
                                        </v-list-item-content>

                                        <v-list-item-content class="f--end-center">
                                            <v-img :lazy-src="item.path_image" :src="img_qrcode" max-height="120px" max-width="120px"></v-img>
                                        </v-list-item-content>
                                    </v-list-item>

                                    
                                    <v-row class="ma-0">
                                        <v-col cols="12" lg="6" >     
                                            <v-btn elevation="2" class="font-14 px-1 " width="100%" outlined color="#88B358" title="คัดลอกเลขบัญชี"
                                                style="border-radius:10px;" @click="copyText(item.bank_number)">
                                                <v-icon>mdi-checkbox-marked-circle</v-icon> คัดลอกเลขบัญชี
                                            </v-btn>
                                        </v-col>
                                        <v-col cols="12" lg="6">
                                            <v-btn elevation="2" class="font-14 px-1 " width="100%" outlined color="#8EBBDC" title="ดาวน์โหลด QR CODE"
                                                style="border-radius:10px;" @click="downloadImage(item.path_image)" >
                                                <v-icon>mdi-magnify</v-icon> ดาวน์โหลด QR
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                    
                                </v-card>
                           </v-col>
                        </v-row>

                        <v-row class="pt-3">
                            <v-col cols="12"> 
                                <h2 class="font-18">แจ้งการชำระเงิน</h2>
                            </v-col>
                            <v-col cols="12 text-center flex-center-fix">
                                <v-form-group>
                                    <v-file-input id="fileUpload_logo_invioce" accept="image/*" @change="onFile" v-model="logo_invioce_input"/>
                                    <label class="required--text font-18">
                                        * กรุณาแนบหลักฐานการโอนเงิน </label>
                                    <v-img v-if="logo_invioce !== null" :lazy-src="img_holder_cert" :src="logo_invioce"
                                    class="preview profile_img">
                                        <v-btn elevation="4" class="mt-2 btn_edit_logo" outlined color="#FEA06C"
                                            title="อัพโหลดรูปภาพใบประกอบวิชาชีพ" @click="getFile_invioce">
                                            <v-icon>mdi-pencil</v-icon>
                                        </v-btn>
                                    </v-img>
                                    <v-img v-else :lazy-src="img_holder_cert" :src="img_holder_cert" class="preview profile_img">
                                        <v-btn elevation="4" class="mt-2 btn_edit_logo" outlined color="#FEA06C"
                                            title="อัพโหลดรูปภาพใบประกอบวิชาชีพ" @click="getFile_invioce">
                                            <v-icon>mdi-pencil</v-icon>
                                        </v-btn>
                                    </v-img>
                                </v-form-group>
                            </v-col>
                            <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                                <div class="title_page ma-3" style="justify-content:center;">
                                    <v-btn type="submit" class="btn_add_data" elevation="4" large>ยืนยันคำสั่งซื้อ</v-btn>
                                </div>
                            </v-col>
                        </v-row>
                    </v-card-text>
                   </v-form>
                </v-card>
  
            </v-col>
        </v-row>
      </div>
    </div>
  </template>
  
  <script>
  import bank_kasikorn from "@/assets/arin_assets/bank-kasikorn-02.png";
  import bank_krungsri from "@/assets/arin_assets/bank-krungsri-02.png";
  import bank_krungthai from "@/assets/arin_assets/bank-thai-02.png";
  import img_holder_cert from "@/assets/arin_assets/image_certification.png";
  import img_qrcode from "@/assets/arin_assets/qrcode.jpg";
  import { HTTP_ARIN } from "@/axios_arin";
  import { HTTP } from "@/axios";
  import { formatPrice } from "@/js/handler";
  import Swal from "sweetalert2";
  
  export default {
    inject: {
      theme: {
        default: {
          isDark: false,
        },
      },
    },
    name: "Pos_debt_balance_pay_bank",
    data() {
      return {
        bank_kasikorn: bank_kasikorn,
        bank_krungsri: bank_krungsri,
        bank_krungthai: bank_krungthai,
        img_qrcode: img_qrcode,
        img_holder_cert: img_holder_cert,
        dialog_cancel_order: false,
        loading_page: false,
        panel: -1,
        disabled: false,
        footer_Props: {
          'items-per-page-text': 'รายการต่อหน้า'
        },
        sub_menu: [
          {
            text: 'ระบบ POS',
            disabled: false,
          },
          {
            text: 'ออกใบสั่งซื้อ',
            disabled: false,
          },
          {
            text: 'ยอดหนี้ของฉัน',
            disabled: false,
          },
          {
            text: 'ชำระเงิน',
            disabled: false,
            href: '#',
          },
        ],
        data_list: [],
        total: 0,
        start_date: null,
        logo_invioce: null,
        customer_id: null,
        order_code: null,
        logo_invioce_input: null,
        
      }
    },
    methods: {
       onFile(payload) {
      if (payload !== null && payload !== undefined) {
        const file = payload
        let extall = "png,PNG,jpeg,JPEG,jpg,JPG";
        let file_ext = file.name;
        let ext = file_ext.split('.').pop().toLowerCase();
        if (parseInt(extall.indexOf(ext)) < 0) {
          Swal.fire({
            text: 'อัพโหลดได้เฉพาะไฟล์ รูป หรือ (.png, .PNG, .jpeg, .JPEG, .jpg, .JPG)',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.logo_invioce = null
          })
        } else {
          if (file) {
            this.logo_invioce = URL.createObjectURL(file)
            URL.revokeObjectURL(file)
            // console.log(URL);
          } else {
            this.logo_invioce = null
          }
        }
      } else {
        this.logo_invioce = null
      }
    },
      copyText(textToCopy){
          navigator.clipboard.writeText(textToCopy);
      },
       formatPrice(value) {
      return formatPrice(value);
    },
      link(link) {
        window.location.href = link;
      },
      cancel_order() {
        this.dialog_cancel_order = true;
      },
      async downloadImage(url) {
         const imageUrl = url; // Replace with your API endpoint

      try {
        const response = await fetch(imageUrl);
        const blob = await response.blob();

        // Create a download link
        const downloadLink = document.createElement("a");
        downloadLink.href = URL.createObjectURL(blob);
        downloadLink.download = "image.jpg"; // Set the desired filename

        // Append the link to the body and trigger the download
        document.body.appendChild(downloadLink);
        downloadLink.click();

        // Clean up: remove the temporary link
        document.body.removeChild(downloadLink);
      } catch (error) {
        console.error("Error downloading image:", error);
      }
      },
   async getDebtbalancepay(){
       let config = {
                    headers: {
                        'Content-Type': 'application/json',
                        "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
                    }
                }
                let id = this.$route.query.id
                let url = this.$route.query.status == 0 ? `/credit/current/billing/pay/${id}` : `/credit/list/${id}`
               await HTTP_ARIN.get(url, config).then((res) => {
                    if (res.data.successful === true) {
                       this.data_list = res.data.bank
                       this.total = res.data.total
                       this.start_date = res.data.start_date
                       this.customer_id = res.data.customer_id
                       this.order_code = res.data.order_code
                    }
                })
    },
    saveData(){
       if (this.$refs.form.validate()) {
          let formData = new FormData();
         if(this.$route.query.status == 0){
          formData.append('slip_image', this.logo_invioce_input)
          formData.append('customer_id', this.customer_id)
          formData.append('id', this.$route.query.id)
         }else{
          formData.append('slip_image', this.logo_invioce_input)
          formData.append('customer_id', this.customer_id)
          formData.append('order_code', this.order_code)
          formData.append('order_wholesale_credit_list_id', this.$route.query.id)
         }
          let config = {
                  headers: {
                    'Content-Type': 'multipart/form-data',
                    "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
                  }
                };
                let url = this.$route.query.status == 0 ? `/wholesaleshops/credits/submit/pay` : `wholesaleshops/credits/list/submit/pay`
          HTTP.post(url, formData, config)
            .then((res) => {
              if (res.data.sucesss === true) {
                let timerInterval
                Swal.fire({
                  title: 'เสร็จสิ้น',
                  text: 'แก้ไขข้อมูลเรียบร้อย',
                  icon: 'success',
                  timer: 2000,
                  timerProgressBar: true,
                  didOpen: () => {
                    Swal.showLoading()
                    timerInterval = setInterval(() => { }, 100)
                    this.$router.push('/arin/pos/posdebtbalancelist')
                  },
                  willClose: () => {
                    clearInterval(timerInterval)
                    setTimeout(function () {
                     this.$router.push('/arin/pos/posdebtbalancelist')
                    });
                  }
                })
              }
              else {
                Swal.fire({
                  title: 'แจ้งเตือน',
                  text: 'ไม่สามารถดำเนินการได้ กรุณาลองใหม่อีกครั้ง!',
                  icon: 'error',
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: `ตกลง`,
                  denyButtonText: `ยกเลิก`,
                })
              }
            })
        }
    }
  },
  mounted(){
    this.getDebtbalancepay()
  }
  }
  </script>
  
  <style scoped>
  /* .progress-bar {
  position: relative;
  height: 20px;
  width: 100%;
  } */
  
  .bank-p{
    padding-left: 20px;
    border-radius: 10px;
    border: #D6BFAF solid;
    box-shadow: 1px 1px 3px 0px #c4c4c4;
  }

  .f--end-center{
    align-items: flex-end;
    justify-content: center;
  }
  .btn_edit_logo {
    border-radius: 10px;
    background-color: #FFF;
    position: absolute;
    top: 8px;
    right: 16px;
    }

  .emply-boder
  {
    border-color: #ffffff !important;
  }
  
  .table-hight
  {
    height: auto !important;
  }

    .boder-D6BFAF
    {
    border: #D6BFAF solid;
    }

  
  .text_title {
    color: #616A6B;
    font-weight: bold;
    font-size: 16px;
  }
  .line {
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  }
  
  .number {
  position: absolute;
  top: -20px;
  right: 0;
  z-index: 2;
  }
  
    .color-green
    {
        color: #88B358;
    }
  
    .font-bold-36 {
        font-size: 36px;
        font-weight: bold; 
    }

    .font-red{
        color:#EC6162;
    }
    
    .text-white {
       color: #FFF !important;
    }
    
    .font-14 {
        font-size: 14px !important;
    }
  
    .font-16 {
        font-size: 16px;
    }
    .font-18 {
        font-size: 18px;
    }
  
    .font-22 {
        font-size: 22px;
    }
  
  
    .font-bold {
        font-weight: bold;
    }
    .input-radius {
        border-radius: 10px;
    }
  
    .btn-red-icon {
        color: #EC6162;
        background-color: white;
        font-size: 14px;
        font-weight: bold;
    }
  
    .bg-red {
        background-color: #EC6162
    }

    .bg-green {
        background-color: #88B358
    }
  
    .header_title {
        font-weight: 600;
        font-size: 20px;
        color: #616A6B;
    }
    
    .font_mobile {
        font-size: 14px !important;
    }
    
    .grid_three {
        display: flex;
        justify-content: space-between;
    }
  
    .flex-center-fix {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
   
    
    .tag_arin_magnify {
        border: 1px solid #FEA06C;
        color: #FEA06C;
        font-weight: 500;
        font-size: 16px;
        border-radius: 10px;
        background-color: #FFFFFF;
    }
    
    .preview {
        border-radius: 10px;
    }

    .preview.profile_img {
        max-width: 300px;
        border-radius: 30px;
    }
    
    .btn_pay {
        font-size: 16px;
        color: #FFF;
        background: linear-gradient(90deg, #A82B2C 0%, rgba(136, 179, 88, 0) 100%), #EC6162 !important;
        border-radius: 10px;
        width: 50%;
    }
    
    .btn_add_data_submit {
        font-size: 16px;
        color: #FFF;
        /* background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important; */
        border-radius: 10px;
        width: 15%;
    }
  
  @media only screen and (min-width: 0px)AND (max-width: 361px) {
    .btn_add_data {
      font-size: 16px;
      color: #FFF;
      background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
      border-radius: 10px;
      width: 100%;
    }
  
    .btn_add_data_submit {
      font-size: 16px;
      color: #FFF;
      border-radius: 10px;
      width: 100%;
    }
  }
  
  @media only screen and (max-width: 600px) {
    .btn_add_data {
      font-size: 16px;
      color: #FFF;
      background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
      border-radius: 10px;
      width: 100%;
    }
  
    .btn_add_data_submit {
      font-size: 16px;
      color: #FFF;
      border-radius: 10px;
      width: 50%;
    }
  }
  
  @media only screen and (min-width: 601px) AND (max-width: 960px) {
    .btn_add_data {
      font-size: 16px;
      color: #FFF;
      background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
      border-radius: 10px;
      width: 50%;
    }
  
    .btn_add_data_submit {
      font-size: 16px;
      color: #FFF;
      border-radius: 10px;
      width: 50%;
    }
  }
  
  @media only screen and (min-width: 961px) AND (max-width: 1264px) {
    .btn_add_data {
      font-size: 16px;
      color: #FFF;
      background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
      border-radius: 10px;
      width: auto;
    }
  
    .btn_add_data_submit {
      font-size: 16px;
      color: #FFF;
      border-radius: 10px;
      width: 50%;
    }
  }
  
  @media only screen and (min-width: 1265px) AND (max-width: 1904px) {
    .btn_add_data {
      font-size: 16px;
      color: #FFF;
      background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
      border-radius: 10px;
      width: auto;
    }
  
    .btn_add_data_submit {
      font-size: 16px;
      color: #FFF;
      border-radius: 10px;
      width: 25%;
    }

  }
  
  
  </style>
  